import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { capitalize } from 'helpers'

const Grouped = ({ name, category, props, keys }) => {
    const value = props[category];

    return (
        name && (
            <li className="item item__grouped">
                <span className="item__label">{name}</span>
                <div className="item__value">
                    {keys.map((item, key) => {
                        const classes = cx({ 'item__new-line': item.__id !== 'postcode' });
                        let __html = `
                        ${item.__id !== 'email'
                                ? (value[item.__id] && capitalize(value[item.__id]))
                                : value[item.__id]
                            }
                        ${item.__id !== 'postcode' ? '<br />' : ' '}
                        `;

                        return (
                            <span
                                className={classes}
                                key={key}
                                dangerouslySetInnerHTML={{ __html }}
                            />
                        );
                    })}
                </div>
            </li>
        )
    );
};

Grouped.propTypes = {
    name: PropTypes.string,
    keys: PropTypes.array,
    category: PropTypes.string,
    props: PropTypes.object,
};

export default Grouped;
